interface LoadErrorProps {
  /** Qué se intentaba cargar, en plural y con artículo: "las alertas", "los vehículos". */
  what: string;
  error: Error;
}

/**
 * Una carga que FALLÓ no es una lista vacía. Sin este aviso, Alertas decía
 * "Sin alertas" y Vehículos "No se encontraron vehículos" cuando el backend
 * había respondido 500 o 403: en una pantalla de seguridad, decir "todo
 * tranquilo" tras un error es peor que no decir nada.
 *
 * Mismo aspecto que el aviso que ya usan Viajes, Novedades y Gastos.
 */
export function LoadError({ what, error }: LoadErrorProps) {
  return (
    <div
      role="alert"
      style={{ padding: '2rem', textAlign: 'center', background: 'var(--bg-surface)', border: '1px solid rgba(239,68,68,0.3)', borderRadius: 'var(--radius-xl)', color: '#EF4444' }}
    >
      No se pudieron cargar {what}: {error.message}
    </div>
  );
}
